// Lightweight dev-only logger. Console output is silenced in production
// to avoid leaking internals. Swap for Sentry / Datadog later if needed.

const IS_DEV = process.env.NODE_ENV !== 'production';

export const logger = {
  error: (...args) => { if (IS_DEV) console.error(...args); },
  warn:  (...args) => { if (IS_DEV) console.warn(...args); },
  info:  (...args) => { if (IS_DEV) console.info(...args); },
  debug: (...args) => { if (IS_DEV) console.debug(...args); },
};
